import React, { useState } from 'react';
import { Icon, FdsIcon } from '@tcc/fds';
import { MarketingBanner } from './MarketingBanner';

export const MarketingBannerContainer = () => {
  // Whatever logic you need, then it should go here, specially if involved 3rd party services.
  const [show, setShow] = useState(true);

  return (
    <MarketingBanner
      show={show}
      message="It is a long established fact that a reader will be distracted, It is a long established fact that a reader will be distracted"
      icon={<Icon icon={FdsIcon.ArrowUpward} />}
      mainActionLabel="Learn More"
      onMainActionClick={() => {
        // eslint-disable-next-line no-console
        console.log('onMainActionClick');
      }}
      dismissLabel="Dismiss"
      onDismiss={() => setShow(false)}
    />
  );
};
